export function SectionHeading({
  eyebrow,
  title,
  intro,
  center = false,
  light = false,
}: {
  eyebrow?: string;
  title: string;
  intro?: string;
  center?: boolean;
  light?: boolean;
}) {
  return (
    <div className={center ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'}>
      {eyebrow && <p className={`eyebrow mb-3 ${light ? 'text-gold-soft' : ''}`}>{eyebrow}</p>}
      <h2 className={`font-display text-3xl font-medium leading-tight sm:text-4xl ${light ? 'text-cream' : 'text-espresso'}`}>
        {title}
      </h2>
      <div className={`rule-gold mt-5 ${center ? 'mx-auto' : ''}`} />
      {intro && (
        <p className={`mt-5 font-body text-base leading-relaxed ${light ? 'text-cream/80' : 'text-muted'}`}>
          {intro}
        </p>
      )}
    </div>
  );
}
